export const ORDER_BY_STOPPER_RULE = ['created_on', 'modified_on'] as const;

export const CHECK_RESULT_STOPPER_CHECK = [
  'AcceptedPartialDeliveryQuantityMatches',
  'DeliveryNoteAuthorized',
  'DeliveryNoteExists',
  'DeliveryNoteItemAlreadyBilled',
  'DeliveryNoteMaterialMatches',
  'DeliveryNoteNotCancelled',
  'DeliveryNoteQuantityMatches',
  'DeliveryNoteReferenceExists',
  'DeliveryNoteUnitTypeMatches',
  'InvoiceDateExists',
  'InvoiceIDExists',
  'ItemCountExists',
  'ItemNetPriceMatches',
  'ItemTaxRateExists',
  'ItemUnitTypeExists',
  'MaterialNetPriceCalculation',
  'MaterialTaxRateCheck',
  'ReceiverAddressExists',
  'ReceiverNameExists',
  'SenderAddressExists',
  'SenderNameExists',
  'TaxAmountExists',
  'TaxRateCheck',
  'TaxRateExists',
  'TotalNetPriceCalculation',
  'TotalPriceExists',
  'TotalTaxAmountCalculation',
  'UniqueInvoiceID',
] as const;

export const CHECK_RESULT_STOPPER_CHECK_RESULT = [
  'success',
  'error',
  'warning',
  'ignored',
  'na',
] as const;

export const CHECK_RESULT_STOPPER_CHECK_RESULT_VALUE_SHORT = {
  error: 'E',
  ignored: 'I',
  na: 'NA',
  success: 'S',
  warning: 'W',
} as const;

export const CHECK_RESULT_STOPPER_CHECK_RESULT_LABEL = {
  error: 'Fehlerhaft',
  ignored: 'Ignoriert',
  na: 'NA',
  success: 'Erfolgreich',
  warning: 'Warnung',
} as const;
